import React from "react";
import Logo from "../../images/whiteLogo.svg";
import { NavLink, useLocation } from "react-router-dom";
import "./Footer.css";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const location = useLocation();
  const { t } = useTranslation();
  if (location.pathname.startsWith('/student')) {
    return null; // Hide Navbar on Student Dashboard
  }
  return (
    <div className="footer">
      <div className="container">
        <div className="suggestion-block">
          <div className="suggestion-text">
            {t("footerSuggestion1")} <span className="text-black">{t("footerSuggestion2")}</span> — {t("footerSuggestion3")}
          </div>
          <div className="footer-input-block">
            <input placeholder={t("footerInputPlaceholder")} type="text" className="suggestion-input" />
            <button className="suggestion-btn">{t("footerSendBtn")}</button>
          </div>
        </div>
        <div className="footer-block">
          <div className="footer-logo">
            <a className="logo-img" href="#">
              <img src={Logo} alt="Logo" />
            </a>
          </div>
          <ul className="footer-nav-list">
            <li>
              <NavLink to={"/"} className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}>
                {t('home')}
              </NavLink>
            </li>
            <li>
              <NavLink to={"/courses"} className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}>
                {t('courses')}
              </NavLink>
            </li>
            <li>
              <NavLink to={"/partners"} className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}>
                {t('partners')}
              </NavLink>
            </li>
            <li>
              <NavLink to={"/about"} className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}>
                {t('about')}
              </NavLink>
            </li>
          </ul>
          <div className="footer-bottom">
            <p className="footer-stay">{t("footerStayInTouch")}</p>
            <div className="addres-block">
              <a href="https://facebook.com" className="addres-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://instagram.com" className="addres-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="https://telegram.org" className="addres-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-telegram-fill"></i>
              </a>
              <a href="https://twitter.com" className="addres-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-twitter-fill"></i>
              </a>
            </div>
            <div className="footer-line-box">
              <div className="footer-line"></div>
              <p className="footer-in">{t("footerCopyright")}</p>
              <div className="footer-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;